import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { BreadcrumbItem, BreadcrumbsWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration/useStatsigExperiment'
import Directory, { Path } from '@src/quince-site-common/src/domains/Directory'
import useDeviceInfo from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { BreadcrumbsPdpDSWidget } from './breadcrumbs-pdp-ds-widget'
import { BreadcrumbsPdpWidgetLegacy } from './breadcrumbs-pdp-widget-legacy'

// @i18n-ignore
const PDP_BREADCRUMB_TEST_ID = 'pdp-breadcrumb'

/**
 * PDP-PL breadcrumbs router. Applies the same `PDP_BREADCRUMB` trim as non-PL (control → last 2
 * crumbs, any other bucket → full chain) before branching, so both leaves get the same chain.
 * Bypasses the `BreadCrumb` router, which couples that trim to non-PL gallery gutters.
 */
const BreadcrumbsPdpComponent = (props: PLTypedWidgetProps<BreadcrumbsWidgetData>) => {
  const { deviceType } = useDeviceInfo()
  const breadCrumbs = Array.isArray(props.data.breadCrumbsData?.breadCrumbs)
    ? props.data.breadCrumbsData.breadCrumbs
    : []
  const breadCrumbExp = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_BREADCRUMB)
  const isControlBucket = breadCrumbExp.experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.CONTROL
  const visibleCrumbs = isControlBucket ? breadCrumbs.slice(-2) : breadCrumbs
  const directory = new Directory({
    paths: visibleCrumbs.map(
      (breadcrumb: BreadcrumbItem) =>
        new Path({
          displayName: breadcrumb.name,
          route: breadcrumb.slug,
        }),
    ),
  })

  if (shouldUseDesignSystem()) {
    return <BreadcrumbsPdpDSWidget directory={directory} deviceType={deviceType} testId={PDP_BREADCRUMB_TEST_ID} />
  }
  return <BreadcrumbsPdpWidgetLegacy directory={directory} deviceType={deviceType} testId={PDP_BREADCRUMB_TEST_ID} />
}

export const BreadcrumbsPdpWidget: PLTypedWidgetInterface<BreadcrumbsWidgetData, WidgetType.BREADCRUMBS> = {
  id: WidgetType.BREADCRUMBS,
  errorBoundary: PLBaseErrorBoundary,
  render: BreadcrumbsPdpComponent,
}
